import React from 'react';

interface HeroHeaderProps {
  badgeText?: string;
  titleMain?: string;
  titleQuestion?: string;
  highlightText?: string;
  subtext?: string;
}

export const HeroHeader: React.FC<HeroHeaderProps> = ({
  badgeText = "SERVICIO TÉCNICO ESPECIALIZADO",
  titleMain = "Reparación de Notebooks:",
  titleQuestion = "¿En qué equipo",
  highlightText = "necesitás ayuda",
  subtext = "REPARACIÓN DE NOTEBOOKS, MACBOOKS, GAMERS Y DRONES · DIAGNÓSTICO SIN CARGO EN CABA",
}) => {
  return (
    <div className="w-full py-8 px-4 font-sans bg-slate-200">
      
      {/* 1. Badge superior celeste con el punto azul */}
      <div className="inline-flex items-center gap-2 bg-sky-200/70 text-sky-600 px-3 py-1.5 rounded-lg text-xs font-bold tracking-wider mb-4">
        <span className="h-2 w-2 rounded-full bg-sky-500"></span>
        <span className="uppercase">{badgeText}</span>
      </div>

      {/* 2. Título principal en dos líneas */}
      <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-slate-900 leading-tight tracking-tight mb-6">
        <div>{titleMain}</div>
        <div>
          {titleQuestion}{' '}
          <span className="text-sky-500">{highlightText}</span>?
        </div>
      </h1>

      {/* 3. Subtexto con la pequeña línea decorativa a la izquierda */}
      <div className="flex items-center gap-3">
        <div className="h-0.5 w-8 bg-sky-400 shrink-0"></div>
        <p className="text-xs sm:text-sm font-semibold text-slate-500 tracking-wider uppercase">
          {subtext}
        </p>
      </div>

    </div>
  );
};